import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import { IMyDpOptions } from 'mydatepicker';
import { API_BASE_URL, ENDPOINTS } from '../app.config';
import Utils from '../app.utilities';
import { CompanyService } from '../company.service';

const utilities = new Utils();

@Component({
  selector: 'app-playlist-slideshow',
  templateUrl: './playlist-slideshow.component.html',
  styleUrls: ['./playlist-slideshow.component.css']
})
export class PlaylistSlideshowComponent implements OnInit {
  route: ActivatedRoute;
  companyService: CompanyService;
  toaster: ToasterService;
  companyName: string;
  userRole: string;
  baseUrl: string;
  currentIndex: number;
  windowHeight: any;
  windowWidth: any;
  sub: any;
  companyId: any;
  playlistId: any;
  playlist: any;

  constructor(
    route: ActivatedRoute,
    companyService: CompanyService,
    toaster: ToasterService,
  ) {
    this.route = route;
    this.companyService = companyService;
    this.toaster = toaster;
  }

  ngOnInit() {
    document.body.style.padding = '0';
    document.body.style.backgroundColor = 'white';
    document.body.style.backgroundImage = 'none';
    this.baseUrl = API_BASE_URL;
    this.currentIndex = -1;
    this.windowHeight = window.innerHeight;
    this.windowWidth = window.innerWidth;
    this.sub = this.route.params.subscribe(params => {
      this.companyId = params.companyId;
      this.playlistId = params.playlistId;
      this.companyService.setCompanyId(this.companyId);
      this.getPlaylistInfo();
      this.getCompanyInfo();
      this.getUserInfo();
    });
  }

  getCompanyInfo() {
    const _self = this;
    axios
      .get(ENDPOINTS.GET_COMPANIES + '/' + _self.companyId)
      .then(response => {
        _self.companyName = response.data.name;
      });
  }

  getUserInfo() {
    const _self = this;
    axios.get(ENDPOINTS.GET_CURRENT_USER).then(
      response => {
        _self.userRole = utilities.getUserRole(response.data);
      },
      error => {},
    );
  }

  getPlaylistInfo() {
    const _self = this;
    axios
      .get(
        ENDPOINTS.PLAYLIST.replace(':companyId', this.companyId) +
        '/' +
        this.playlistId,
      )
      .then(response => {
        _self.playlist = response.data;
        _self.loadFrames();
      });
  }

  loadFrames() {
    const _self = this;
    _self.currentIndex++;
    if (_self.currentIndex === _self.playlist.playlist_assets.length) {
      _self.currentIndex = 0;
    }
    if (_self.playlist.playlist_assets[_self.currentIndex]) {
      setTimeout(() => {
        _self.loadFrames();
      }, _self.playlist.playlist_assets[_self.currentIndex].duration * 1000);
    }
  }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/playlist-slideshow/playlist-slideshow.component.ts